import $http from '../../../axios-instance';
import $http_fds from "../../../axios-instance-fds";
/**
 *
 * @param commit
 * @param data
 * @returns {Promise<void>}
 */
export async function stateChildValue({commit}, data) {
  commit(`${data.module}/setState`, data, {root: true});
}

/**
 * Obtener Listas por el código del control
 */
export async function obtenerUnidadesDeMedida({commit, state}, controls) {
  if (state.unidades_medida_cargadas === 0) {
    commit('setUnidadesMedidaCargadas', 1);
    commit('dashboard/load', true, {root: true});
    const data = {
      controls: controls
    };

    await $http_fds.post(`sistema/listas/control`, data)
      .then((response) => {
        commit('setUnidadesMedida', response.data.data);
        commit('dashboard/load', false, {root: true});
      }).catch(() => {
        commit('setUnidadesMedidaCargadas', 1);
        commit('dashboard/load', false, {root: true});
      });
  }
}

export function filtrarUnidadesMedida({commit, state}, um_tipo) {
  if (state.unidades_medida_cargadas === 1 && um_tipo !== null) {
    if (state.unidades_medida[um_tipo] !== undefined) {
      return state.unidades_medida[um_tipo];
    } else {
      return [];
    }
  } else {
    return [];
  }
}
